<script>
  import Fa from "svelte-fa"
  import {
    faArrowUpRightFromSquare,
    faXmark,
    faPlus
  } from "@fortawesome/free-solid-svg-icons"

  export let links = []

  let showForm = false
  let newUrl = ""
  let newTitle = ""
  let urlInput

  function addLink() {
    if (!newUrl.trim()) return

    // Ensure URL has protocol
    let url = newUrl.trim()
    if (!url.match(/^https?:\/\//)) {
      url = "https://" + url
    }

    links = [...links, { url, title: newTitle.trim() || "" }]
    newUrl = ""
    newTitle = ""
    showForm = false
  }

  function removeLink(index) {
    links = links.filter((_, i) => i !== index)
  }

  function handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      addLink()
    } else if (event.key === "Escape") {
      showForm = false
      newUrl = ""
      newTitle = ""
    }
  }

  function openForm() {
    showForm = true
    setTimeout(() => urlInput?.focus(), 50)
  }

  function getDisplayUrl(url) {
    try {
      return new URL(url).hostname.replace(/^www\./, "")
    } catch {
      return url
    }
  }
</script>

<div class="mt-2 flex flex-wrap items-center gap-2 text-sm">
  {#each links as link, i}
    <a
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      class="group inline-flex items-center gap-1.5 px-2 py-0.5 bg-slate/5 border border-slate/20 hover:border-accent/50 hover:bg-accent/5 rounded-xl text-fg-muted hover:text-accent transition-colors"
      data-controller="tooltip"
      data-tooltip-content-value={link.url}
    >
      <Fa icon={faArrowUpRightFromSquare} class="text-xs opacity-50" />
      <span class="truncate max-w-48"
        >{link.title || getDisplayUrl(link.url)}</span
      >
      <button
        type="button"
        class="hidden group-hover:inline-flex text-danger hover:!text-danger-hover ml-0.5"
        on:click|preventDefault|stopPropagation={() => removeLink(i)}
      >
        <Fa icon={faXmark} class="text-xs" />
      </button>
    </a>
  {/each}

  {#if showForm}
    <div class="inline-flex items-center gap-1.5">
      <input
        bind:this={urlInput}
        bind:value={newUrl}
        type="text"
        placeholder="URL"
        class="link-input w-32"
        on:keydown={handleKeydown}
      />
      <input
        bind:value={newTitle}
        type="text"
        placeholder="Title"
        class="link-input w-24"
        on:keydown={handleKeydown}
      />
      <button
        type="button"
        class="text-accent hover:text-accent-hover text-xs px-1"
        on:click={addLink}
      >
        Add
      </button>
      <button
        type="button"
        class="text-fg-muted hover:text-fg text-xs"
        on:click={() => {
          showForm = false
          newUrl = ""
          newTitle = ""
        }}
      >
        Cancel
      </button>
    </div>
  {:else}
    <button
      type="button"
      class="inline-flex items-center gap-1 text-fg-muted hover:text-accent text-xs transition-colors"
      on:click={openForm}
    >
      <Fa icon={faPlus} class="text-xs" />
      <span>Add link</span>
    </button>
  {/if}
</div>

<style>
  .link-input {
    @apply bg-surface border border-border rounded px-2 py-0.5 text-sm text-fg;
    @apply focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent/20;
  }

  .link-input::placeholder {
    @apply text-fg-muted/50;
  }
</style>
